module.exports = __webpack_public_path__ + "media/images/riders/small/TITOURAN_CAROD-f2d7bf2a07d51dd6773e485113532d3c.png";